import {Map} from 'immutable';
import MultipleChoiceQuestionEditor from './MultipleChoiceEditor.react';
import MultipleChoiceQuestionV2 from './V2/MultipleChoiceQuestion.react';
import MultipleChoiceExplanation from './V2/MultipleChoiceExplanation.react';
import MultipleChoiceResponseStats from './V2/MultipleChoiceResponseStats.react';

export const MultipleChoiceQuestionType = Map({
  type: 'multiple-choice',
  label: 'Multiple Choice',
  questionRenderer: MultipleChoiceQuestionV2,
  explanationRenderer: MultipleChoiceExplanation,
  responseStatsRenderer: MultipleChoiceResponseStats,
  editor: MultipleChoiceQuestionEditor,
  isHidden: false
});
